'use strict';

import BookingInfosCard from 'Components/Front/BookingInfosCard';
export default function Cart(props) {
  const {
    date,
    start,
    end,
    space,
    people,
    amount,
    services,
    disposition,
    hours_count
  } = props;
  let booking = {
    date: date,
    number_of_people: people,
    start_hour: start,
    end_hour: end,
    hours_count: hours_count,
    coworking_space: space,
    disposition: disposition,
    amount: amount,
    services: services
  };
  let output = /*#__PURE__*/React.createElement("div", {
    className: "c-side-widget c-side-widget--cart"
  }, /*#__PURE__*/React.createElement(BookingInfosCard, {
    booking: booking,
    b2b: props.b2b,
    "discount-code": props['discount-code']
  }));
  return output;
}
